/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cost_AnswerInputs */

const en_faq_cost_answer = /** @type {(inputs: Faq_Cost_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That depends on the process, data and integrations. After discovery, we propose a focused first phase with clear deliverables, a timeline and a price for you to review. We agree the scope before building.`)
};

const lv_faq_cost_answer = /** @type {(inputs: Faq_Cost_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tas atkarīgs no procesa, datiem un integrācijām. Pēc izpētes mēs piedāvājam fokusētu pirmo posmu ar skaidriem rezultātiem, termiņu un cenu, ko varat izvērtēt. Par apjomu vienojamies pirms izstrādes.`)
};

/**
* | output |
* | --- |
* | "That depends on the process, data and integrations. After discovery, we propose a focused first phase with clear deliverables, a timeline and a price for you..." |
*
* @param {Faq_Cost_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_cost_answer = /** @type {((inputs?: Faq_Cost_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cost_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_cost_answer(inputs)
	return en_faq_cost_answer(inputs)
});